// extracted by mini-css-extract-plugin
module.exports = {"nav":"navigation_nav__2WPD9","list":"navigation_list__3Isem","linkItem":"navigation_linkItem__3gaJC","button":"navigation_button__2jJ07","link":"navigation_link__1mqGZ"};